import React from "react";
import { Layout, Tooltip, Button, BackTop } from "antd";
import { useDispatch } from "react-redux";
import { FiMenu } from "react-icons/fi";
// component
import HeaderUser from "component/header/header_user";
//redux
import { toggleCollapse } from "../../../store/bailiff/nav/nav.action";
import logo from "../../../asset/img/logo/client.png";
import OnboardButton from "component/header/onboard_button";

const LayoutHeader = (props) => {
  // -------------------------- STATE --------------------------
  const { title } = props;
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  const toggleMenu = () => {
    dispatch(toggleCollapse());
  };

  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <div className="flex h-[70px] flex-row items-center justify-between bg-white">
        <div className="flex flex-row items-center gap-2">
          {renderMenu()}
          {renderTitle()}
        </div>
        <div className="hidden flex-row items-center justify-end md:block">
          {renderLogout()}
        </div>
      </div>
    );
  };

  const renderMenu = () => {
    return (
      <Tooltip title="Menu">
        <Button
          shape="default"
          onClick={() => toggleMenu()}
          icon={
            <span className="anticon">
              <FiMenu />
            </span>
          }
        />
      </Tooltip>
    );
  };

  const renderTitle = () => {
    const size = 35;
    return (
      <div className="flex h-[70px] flex-row gap-2">
        <div className="flex flex-row items-center">
          <a
            href="/"
            style={{
              display: "flex",
              alignItems: "center",
              width: size,
              height: size,
            }}
          >
            <img src={logo} style={{ width: size, height: size }} alt="logO" />
          </a>
        </div>
        <div className="flex flex-row items-center text-[16px] font-bold">
          {title || ""}
        </div>
      </div>
    );
  };

  const renderLogout = () => {
    return (
      <div
        className="flex flex-row items-center gap-5"
        style={{ paddingRight: 20 }}
      >
        <OnboardButton />
        <HeaderUser />
      </div>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Layout.Header className="min-h-[70px] bg-white">
      {renderBody()}
      <BackTop className="z-[99]" />
    </Layout.Header>
  );
};

export default LayoutHeader;
